import type { ModalFuncProps } from 'antd';
import { isMobileViewportWidth } from './breakpoints';

// Phones: antd's imperative dialogs (Modal.confirm / Modal.info …) and
// Popconfirm-style warnings become a native action sheet — slides up from the
// bottom edge, full width, message on top and full-width stacked buttons
// (primary first) pinned above the home indicator. Styles: `.m-action-sheet`
// in index.less (on top of the `.m-sheet` bottom-sheet base). Desktop gets the
// props back untouched.

const isRtlPage = () =>
  typeof document !== 'undefined' &&
  (document.documentElement.dir === 'rtl' ||
    !!document.querySelector('.App.direction-rtl')); // App.tsx root class

export const withPhoneActionSheet = (props: ModalFuncProps): ModalFuncProps => {
  if (typeof window === 'undefined' || !isMobileViewportWidth(window.innerWidth)) {
    return props;
  }
  return {
    ...props,
    centered: false,
    width: '100%',
    // slide up from the bottom edge instead of zooming in
    transitionName: 'ant-move-down',
    // a tap on the dimmed page dismisses an action sheet (= cancel) unless
    // the caller explicitly asked otherwise
    maskClosable: props.maskClosable ?? true,
    direction: props.direction ?? (isRtlPage() ? 'rtl' : 'ltr'),
    wrapClassName: ['m-sheet', 'm-action-sheet', props.wrapClassName]
      .filter(Boolean)
      .join(' '),
  };
};
